import React, { useState, useEffect } from "react";
import { Form, Input, Button, Select, Row, Col, message, DatePicker, Typography } from "antd";
import { useHistory, useLocation } from "react-router-dom";
import LeftLayout from "../pageHeader/LeftLayout";
import _NewapplicationService from "../../modules/NewapplicationService";
import { APPLICATION_SUBMIT_SUCCESSFULLY, SUBMISSION_FAILED, COMMON_ERROR_MSG } from "../../constants/constants";
import { routes } from "../../routes/Routes";
import ShowApplicationId from "../NewApplication/ShowApplicationId";
import AlphabetInput from "../../components/AlphabetInput";
import PhoneInput from "react-phone-input-auto-format";
import moment from 'moment';
import ApplicationProgressBar from "./ApplicationProgressBar";
import { LeftOutlined, RightOutlined,ArrowRightOutlined} from "@ant-design/icons";
import ButtonComponent from "../../components/Button/Button";


const { Title } = Typography;
const { Option } = Select;

const CoBorrowersDetails = () => {
    const [loading, setLoading] = useState(false);
    const [form] = Form.useForm();
    const history = useHistory();
    const [applicantInfo, setApplicantInfo] = useState({});
    let APPLICATION_TYPE_ID = localStorage.getItem("applicationTypeId");
    const applicationId = localStorage.getItem("ApplicationId");
    useEffect(() => {
          window.scrollTo(0, 0);
        }, []);
    const location = useLocation();
    let data = location.state;
    let applnObjId = "";
    let activeKeyTab = null;
    let fromDashboard = false;

    if (data && data.applicationObjId) {
        applnObjId = data.applicationObjId;
    }

    if (data && data.isFromDashboard) {
        fromDashboard = data.isFromDashboard;
    }

    if (data && data.isFromDashboard) {
        fromDashboard = data.isFromDashboard;
    }

    if (data && data.activeKey) {
        activeKeyTab = data.activeKey;
    }

    const [appObjId] = useState(applnObjId);
    const [isFromDashboard] = useState(fromDashboard);
    const [tabActiveKey] = useState(activeKeyTab);

    useEffect(() => {
        getApplicantDetailsByID();
    }, []);

    useEffect(() => form.resetFields(), [applicantInfo]);

    // const onFinish = async (values) => {
    //     history.push({
    //         pathname: routes.identificationOfcoBorrower.path,
    //     });
    //     // setLoading(true);
    //     // let reqObj = {
    //     //     firstName: values.firstName,
    //     //     lastName: values.lastName,
    //     //     dob: values.dob,
    //     //     contactNumber: values.contactNumber,
    //     //     applicationType: values.applicationType,
    //     //     relationshipWithApplicant: values.relationshipWithApplicant,
    //     // }
    //     // try {
    //     //     const res = await _NewapplicationService.submitApplicantDetails(reqObj);
    //     //     if (res.data.isSuccess) {
    //     //         setLoading(false);
    //     //         message.success(APPLICATION_SUBMIT_SUCCESSFULLY);
    //     //         //  history.push("/verifyotp");
    //     //     }
    //     // } catch (err) {
    //     //     setLoading(false);
    //     //     message.error(err.message || SUBMISSION_FAILED);
    //     // }
    //     // finally {
    //     //     setLoading(false);
    //     // }

    // };

    const onFinish = async (values) => {
        const dob = values.dob?.format("YYYY-MM-DD");
        setLoading(true);
        let reqObj = {
            Id: localStorage.getItem("Id"),
            ScreenName: "coborrowerdetails",
            ApplicationId: localStorage.getItem("ApplicationId"),
            CoB_FirstName: values.firstName,
            CoB_MiddleInitial: values.middleInitial,
            CoB_LastName: values.lastName,
            CoB_DateOfBirth: dob,
            CoB_ContactNumber: values.contactNumber,
            CoB_Relationship_With_Applicant: values.relationshipWithApplicant,
            IsCoborrowerDetailsCompleted: true,
        }
        try {
            const res = await _NewapplicationService.submitApplicantData(reqObj);
            if (res.data.IsSuccess) {
                setLoading(false);
                message.success(res.data.Message);
                if (isFromDashboard) {
                    history.push({ pathname: routes.dashboard.path, state: { appObjId, activeKey: tabActiveKey } });
                } else {
                    history.push(routes.identificationOfcoBorrower.path);
                }
            } else {
                setLoading(false);
                message.error(res.data.message ? res.data.message : COMMON_ERROR_MSG);
            }
        } catch (err) {
            setLoading(false);
            message.error(err.message || SUBMISSION_FAILED);
        }
        finally {
            setLoading(false);
        }

    };

    let Id = localStorage.getItem("Id");

    const getApplicantDetailsByID = async () => {
        try {
            setLoading(true);
            const res = await _NewapplicationService.getApplicantInformationByApplicationId(isFromDashboard ? appObjId : Id);
            console.log("ab res", res)
            if (res.data) {
                let resObj = res?.data;
                // debugger
                setApplicantInfo({
                    ...resObj,
                    firstName: resObj.CoB_FirstName,
                    middleInitial: resObj.CoB_MiddleInitial,
                    lastName: resObj.CoB_LastName,
                    dob: resObj.CoB_DateOfBirth ? moment(resObj.CoB_DateOfBirth) : null, //TODO
                    contactNumber: resObj.CoB_ContactNumber || "",
                    relationshipWithApplicant: resObj.CoB_Relationship_With_Applicant,
                });

                setLoading(false);
            }
        } catch (e) {
            setLoading(false);
            console.log(e);
        }
    };


    const onBack = () => {
        if (isFromDashboard) {
            history.push({ pathname: routes.dashboard.path, state: { appObjId, activeKey: tabActiveKey } });
        } else {
            if (APPLICATION_TYPE_ID == "4") {
                history.push(routes.applicantsIdentification.path);
            }
        }
    }

    const disableFutureDates = (current) => {
        return current && current > moment().endOf("day");
    };

    return (
        <LeftLayout>
            {/* {applicationId && applicationId !== 'undefined' && applicationId !== 'null' && (
                <div style={{
                    position: "absolute",
                    top: 5,
                    right: 20,
                    margin: 0,
                    zIndex: 1000,
                    maxWidth: "1000px",
                    padding: "8px 16px",
                }}>
                    <ApplicationProgressBar />
                    <Title level={3} style={{ margin: 0 }}>
                        <ShowApplicationId />
                    </Title>
                </div>
            )} */}
            <div>
                {applicationId && applicationId !== 'undefined' && applicationId !== 'null' && (
                    <div>
                        <ApplicationProgressBar />
                        <Title level={5}>
                            {/* <ShowApplicationId /> */}
                        </Title>
                    </div>
                )}
            </div>

            <div className="application-dark-page">
                <div className="application-card">
                    <Row>
                        <Col span={24}>
                            <Title level={3} style={{ marginBottom: 32 }}> Co-Borrower's Details</Title>
                            <Form
                                form={form}
                                layout="vertical"
                                onFinish={onFinish}
                                initialValues={applicantInfo}
                            >
                                <Row gutter={16}>
                                    <Col span={8}>
                                        <Form.Item
                                            label="First Name"
                                            name="firstName"
                                            rules={[{ required: true, message: "First Name is required" }]}
                                        >
                                            <AlphabetInput placeholder="Enter First Name" maxLength={30} />
                                        </Form.Item>
                                    </Col>
                                    <Col span={8}>
                                        <Form.Item
                                            label="Middle Name"
                                            name="middleInitial"
                                            rules={[
                                                { required: true, message: "Middle Name is required" },
                                            ]}
                                        >
                                            <AlphabetInput placeholder="Enter Middle Name" maxLength={30} />
                                        </Form.Item>
                                    </Col>
                                    <Col span={8}>
                                        <Form.Item
                                            label="Last Name"
                                            name="lastName"
                                            rules={[{ required: true, message: "Last Name is required" }]}
                                        >
                                            <AlphabetInput placeholder="Enter Last Name" maxLength={30} />
                                        </Form.Item>
                                    </Col>
                                </Row>

                                <Row gutter={16}>
                                    <Col span={12}>
                                        <Form.Item
                                            label="Date Of Birth"
                                            name="dob"
                                            rules={[{ required: true, message: "Date Of Birth is required" }]}

                                        >
                                            <DatePicker placeholder="Select Date Of Birth" style={{ width: "100%" }} format="MM/DD/YYYY" disabledDate={disableFutureDates} />
                                        </Form.Item>
                                    </Col>
                                    <Col span={12}>
                                        <Form.Item
                                            label="Contact Number"
                                            name="contactNumber"
                                            rules={[
                                                { required: true, message: "Contact Number is required" },
                                                {
                                                    validator: (_, value) => {
                                                        if (!value) {
                                                            return Promise.resolve(); //  Allow empty value if not required
                                                        }
                                                        const digits = value.replace(/\D/g, '');
                                                        if (digits.length === 10) {
                                                            return Promise.resolve();
                                                        }
                                                        return Promise.reject(
                                                            new Error("Wrong format! please use this format (XXX) XXX-XXXX")
                                                        );
                                                    },
                                                }
                                            ]}

                                        >
                                            <PhoneInput
                                                placeholder="Enter Contact Number"
                                                inputComponent={Input}
                                                autoComplete="off"
                                                onChange={(value) => {
                                                    // Remove non-digit characters and store the raw number
                                                    const digits = value.replace(/\D/g, '');
                                                    form.setFieldsValue({ contactNumber: digits });
                                                }}
                                            />


                                        </Form.Item>
                                    </Col>
                                </Row>
                                {/* <Form.Item
                            label="Relationship With Applicant"
                            name="relationshipType"
                            rules={[{ required: true, message: "Please select Relationship" }]}
                        >
                            <Select placeholder="Select">
                                <Option value="personal">Personal</Option>
                                <Option value="business">Business</Option>
                            </Select>
                        </Form.Item> */}
                                <Row>
                                    <Col span={12}>
                                        <Form.Item
                                            label="Relationship With Client"
                                            name="relationshipWithApplicant"
                                            rules={[{ required: true, message: "Relationship With Client is required" }]}

                                        >
                                            <AlphabetInput placeholder="Enter Relationship With Client" maxLength={30} />
                                        </Form.Item>
                                    </Col>
                                </Row>

                                <Form.Item>
                                    <div style={{ display: "flex", justifyContent: "flex-end", gap: 16 }}>
                                        <ButtonComponent
                                            type="default"
                                            onClick={onBack}
                                            icon={<LeftOutlined />}
                                            text="Go Back"
                                        />
                                        <ButtonComponent
                                            type="primary"
                                            htmlType="submit"
                                            disabled={![1,2,4,9].includes(applicantInfo && applicantInfo.Application_Status_Id) ? true : false}
                                            text={
                                                <span>
                                                    Save And Proceed <ArrowRightOutlined />
                                                </span>
                                            }
                                            // text="Save And Proceed"
                                            icon={<RightOutlined />}
                                        />

                                    </div>
                                </Form.Item>
                            </Form>
                        </Col>
                    </Row>
                </div>
            </div>
        </LeftLayout >
    );
};

export default CoBorrowersDetails;